<template lang="pug">
#flow-triggers
  div.triggers-integrations
    .row
      .col-md-12
        h2 Gatilhos
        .titleized Crie gatilhos personalizados para gerar ações automaticamente de acordo com o seu processo.

    .row.row-trigger(v-for='(item, index) in matching')
      .col-md-12(v-if="!item._destroy")
        .row.first-item
          div.line-left
          div.ball
          .col-md-3.fake-width
            .trigger-question Quando um contato for
          .col-md-3
            dropdown-select.field(:options="triggers_options",
                                  :selected="item.trigger_type"
                                  v-model="item.trigger_type",
                                  v-validate="'required'",
                                  @input='setDirty')
          .col-md-3(v-if="item.trigger_type == 'stage'")
            dropdown-select.field(:options="stages_options",
                                  :selected="item.trigger_value"
                                  v-model="item.trigger_value",
                                  v-validate="'required'",
                                  @input='setDirty')
          .col-md-3(v-if="item.trigger_type == 'lost'")
            dropdown-select.field(v-model='item.trigger_value',
                                  data-vv-name='lost_reason_unit',
                                  v-validate="'required'",
                                  :options='lostReasonOptions()')


        .row.trigger-item( :class="[ show_timming_actions.indexOf(item.action_type) > -1 ? '' : 'no-border' ]")
          div.line-faker
          .col-md-2.col-question.fake-half-width
          .col-md-1.no-padding-right
            .trigger-question Quero
          .col-md-3
            dropdown-select.field(:options="item.trigger_type != 'stage' && item.trigger_type != 'lost' ? actions_options : actions_trigger_without_stages",
                                  :selected="item.action_type"
                                  v-model="item.action_type",
                                  v-validate="'required'",
                                  @input='setDirty')

          .col-md-4(v-if="item.action_type == 'change_stage'")
            dropdown-select.field(:options="stages_options",
                                  :selected="item.action_value"
                                  v-model="item.action_value",
                                  v-validate="'required'",
                                  @input='setDirty')

          .col-md-4.contact-list-item-flow(v-if="item.action_type == 'send_to_new_flow'")
            flows(
                  @flow-selected="selectFlow",
                  :position='index',
                  :focus='false',
                  :default_flow="item.action_value",
                  :user_id="current_user_id")

          .col-md-5.no-padding(v-if="item.action_type == 'fill_property'")
            dropdown-select.field.fill-property-field(:options="properties_options",
                                                      :selected="item.action_target"
                                                      v-model="item.action_target",
                                                      v-validate="'required'",
                                                      @input='setDirty')
            .trigger-question com
            input.form-control.fill-property-field(name='name'
                                                    type='text'
                                                    v-validate="'required'"
                                                    v-model='item.action_value')

          .col-md-4(v-if="item.action_type == 'insert_tag'")
            dropdown-multiple-select(@item-selected-items='itemSelectedItems',
                                    :filter_item_selected_ids='item.action_metadata',
                                    :position='index'
                                    :index='index'
                                    :kind='kind_multiple_filter')

          .col-md-4(v-if="item.action_type == 'insert_into_a_group'")
            groups(@group-selected="selectGroup",
                  :position='index'
                  :default_group="item.action_value"
                  :user_id="selected_user")

          .col-md-4(v-if="item.action_type == 'change_responsible'")
            dropdown-select(:options="users_options", v-model="item.action_value", :selected="item.action_value")

          .col-md-1
            .btn-icon-remove(@click='removeTrigger(item, index)')

        .row.trigger-item(v-if="show_timming_actions.indexOf(item.action_type) > -1")
          div.mask
          .col-md-3.col-question.fake-width
          .col-md-3
            dropdown-select.field(:options="timming_options",
                                  :selected="item.timming_type",
                                  v-model="item.timming_type",
                                  v-validate="'required'",
                                  :disabled="(item.trigger_type == 'connected' || item.trigger_type == 'bounced') && item.action_type == 'change_stage'",
                                  @input='setDirty')

          .col-md-3.inline-options(v-if="item.timming_type == 'after'")
            input.form-control.input-delay(name='name'
                                          type='text'
                                          v-validate="'required'"
                                          v-model='item.timming_value')
            dropdown-select.field.input-delay-options(:options="timming_complements",
                                                      :selected="item.timming_complement",
                                                      v-model="item.timming_complement",
                                                      v-validate="'required'",
                                                      @input='setDirty')

    .row.btn-new
      .btn.btn-clean(@click="newTrigger()")
        span.icon-more +
        | {{ $t('flows.actions.addTrigger') }}

</template>

<script>

const helpers = require("../../helpers.coffee");

let view_model = {
  mixins: [
    require('../../mixins/users_options.coffee'),
    require('../../mixins/tags_options.coffee')
  ],

  components: {
    flows: require("../shared/autocomplete/flows.vue"),
    groups: require("../shared/autocomplete/groups.vue"),
    users: require("../contacts/user_dropdown.vue")
  },

  props: {
    triggers: {
      default: null
    }, 
    current_user_id: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      current_company: Session.current_company,
      matching: [],
      default_flow: null,
      triggers_options: [
        { value: "connected", text: this.$t('flows.options.triggers.connected') },
        { value: "bounced", text: this.$t('flows.options.triggers.bounced') },
        { value: "lost", text: this.$t('flows.options.triggers.lost') },
        { value: "stage", text: this.$t('flows.options.triggers.stage') }
      ],
      actions_options: [
        { value: "send_to_new_flow", text: this.$t('flows.options.actions.sendToNewFlow') },
        { value: "change_stage", text: this.$t('flows.options.actions.changeStage') },
        { value: "fill_property", text: this.$t('flows.options.actions.fillProperty') },
        { value: "insert_tag", text: this.$t('flows.options.actions.insertTag') },
        { value: "insert_into_a_group", text: this.$t('flows.options.actions.insertIntoGroup') },
        { value: "change_responsible", text: this.$t('flows.options.actions.changeResponsible') }
      ],
      timming_options: [
        { value: "immediately", text: this.$t('flows.options.timming.immediately') },
        { value: "next_day", text: this.$t('flows.options.timming.nextDay') },
        { value: "after", text: this.$t('flows.options.timming.after') }
      ],
      timming_complements: [
        { value: "hours", text: this.$t('flows.options.timmingComplements.hours') },
        { value: "days", text: this.$t('flows.options.timmingComplements.days') },
        { value: "weeks", text: this.$t('flows.options.timmingComplements.weeks') },
        { value: "months", text: this.$t('flows.options.timmingComplements.months') }
      ],
      actions_trigger_without_stages: [
        { value: "send_to_new_flow", text: this.$t('flows.options.actionsTriggerWithoutStages.sendToNewFlow') },
        { value: "fill_property", text: this.$t('flows.options.actionsTriggerWithoutStages.fillProperty') },
        { value: "insert_tag", text: this.$t('flows.options.actionsTriggerWithoutStages.insertTag') },
        { value: "insert_into_a_group", text: this.$t('flows.options.actionsTriggerWithoutStages.insertIntoGroup') },
        { value: "change_responsible", text: this.$t('flows.options.actionsTriggerWithoutStages.changeResponsible') }
      ],
      stages_options: [
        { value: null, text: this.$t('flows.options.stages') },
      ],
      lost_reason_id: null,
      properties_options: [
        { value: null, text: this.$t('flows.options.properties') },
      ],
      tag_filter: [],
      kind_multiple_filter: 'tag_filter',
      selected_user: Session.current_user.id
    };
  },

  methods: {
    newTrigger() {
      this.matching.push({
        trigger_type: "connected",
        trigger_value: null,
        action_type: "send_to_new_flow",
        action_value: null,
        timming_type: "immediately",
        timming_value: null,
        timming_complement: null,
        action_metadata: []
      });
    },

    setDirty() {
      let action_value
      let obj = this.matching.map(trigger => {
        action_value = trigger.action_value
        if(trigger.action_type == 'change_responsible' && trigger.action_value)
          action_value = trigger.action_value.user_id_eq

        trigger.timming_complement = trigger.timming_complement ? trigger.timming_complement : 'hours'
        return {
          id: trigger.id || null,
          trigger_type: trigger.trigger_type,
          trigger_value: trigger.trigger_value,
          action_type: trigger.action_type,
          action_value: action_value,
          action_target: trigger.action_target,
          action_metadata: trigger.action_metadata.map((id) => { return id.toString() }),
          timming_type:
            trigger.timming_type == "after"
              ? trigger.timming_complement
              : trigger.timming_type,
          timming_value: trigger.timming_value,
          _destroy: trigger._destroy
        };
      });
      this.$emit("update-triggers", obj);
    },

    itemSelectedItems(data) {
      this.matching[data.position].action_metadata = data.selected_items.map((t) => { return t.id })
    },

    selectFlow(flow) {
      this.matching[flow.position].action_value = flow.id;
    },

    selectGroup(group) {
      this.matching[group.position].action_value = group.id
    },

    lostReasonOptions() {
      var result = [];
      result.push({ value: null, text: this.$t('flows.options.lostReason') });
      if (this.$store.getters.lostReasonsCount == 0) {
        this.$store.dispatch("fetchLostReasons");
      }
      var list = this.$store.getters.lostReasonsList;
      var index;
      for (index = 0; index < this.$store.getters.lostReasonsCount; index++) {
        result.push({ value: list[index].id, text: list[index].title });
      }
      return result;
    },

    removeTrigger(item, index) {
      if(item.id) {
        this.matching[index]._destroy = true;
      } else {
        this.matching.splice(index, 1);
      }
      this.$forceUpdate()
      this.setDirty()
    },

    loadCustomFields() {
      Loader.on()
      new CustomFieldsResource().index(this.loadCustomFieldsSuccess, this.loadCustomFieldsFail)
    },

    loadCustomFieldsSuccess(data) {
      this.properties_options = this.properties_options.concat(data.custom_fields.map((field) => { return { value: field.id, text: field.field } }))
      Loader.off()
    },

    loadCustomFieldsFail() {
      Loader.off()
      alertify.error(this.$t('contacts.label.customFieldsFailLoading'))
    }
  },

  computed: {
    show_timming_actions() {
      return ['send_to_new_flow', 'change_stage']
    }
  },

  watch: {
    triggers() {
      if (this.triggers.length > 0 && this.matching.length == 0) {
        this.matching = this.triggers.map(trigger => {
          if(trigger.action_type == 'send_to_new_flow')
            trigger.action_value = trigger.flow
          if(trigger.action_type == 'insert_into_a_group')
            trigger.action_value = trigger.contact_group
          if(trigger.action_type == 'change_responsible')
            trigger.action_value = { user_id_eq: trigger.action_value }
          if(trigger.action_type == 'fill_property' && typeof trigger.action_target == 'string')
            trigger.action_target = this.properties_options.find((propertie) => { return propertie.value == parseInt(trigger.action_target) }).value
          if(!isNaN(trigger.trigger_value) && trigger.trigger_value != null)
            trigger.trigger_value = parseInt(trigger.trigger_value)
          if(trigger.timming_type == 'days' || trigger.timming_type == 'hours' || trigger.timming_type == 'weeks' || trigger.timming_type == 'months') {
            trigger.timming_complement = trigger.timming_type
            trigger.timming_type = 'after'
          }
          return trigger;
        });
      }
    },

    matching: {
      handler(val) {
        this.setDirty();
      },
      deep: true
    }
  },


  created() {
    this.stages_options = this.stages_options.concat(new Contact().stages());
    this.flow_resources = new FlowsResource(this.current_company.id);
    this.current_user_id |= Session.current_user.id;
    this.loadCustomFields()
  }
};

exports.default = helpers.vue_include(view_model, helpers.form);
</script>

<style lang="sass">
@import '../../assets/stylesheets/_variables.sass'

#flow-triggers
  .row-trigger
    padding: 20px

  .first-item
    padding: 10px 0 10px 0

  .trigger-item
    padding: 10px 0 10px 0
    border-left: 1px solid $reev-base-green

  .btn-new
    padding: 10px

  .trigger-question
    text-align: right
    padding: 10px
    font-weight: lighter

  .col-question
    border-bottom: 1px solid $reev-base-green
    margin-top: 19px

  .mask
    position: absolute
    bottom: -1px
    height: 17%
    width: 1px
    background-color: white
    left: 0px

  .ball
    height: 10px
    width: 10px
    border: 2px solid $reev-base-green
    border-radius: 50%
    position: absolute
    left: -4px
    top: 24px

  .v-autocomplete
    position: relative
    width: 100%
    margin-left: 0px
  .v-autocomplete-input-group
    margin-bottom: 0 !important
    width: 100%
  .contact-list-item-flow,
  .v-autocomplete-input-group
    margin-bottom: 30px
    .toggler-inline
      width: 100%
      display: flex
      flex-direction: row
      align-items: center;
    input[type=search]
      flex: 8
      border-radius: 3px;
      border: solid 1px #c4cacf
      padding-left: 8px
      width: 100% !important
      font-size: 13px
      padding: 9px 12px
      position: relative
      height: 100%
      outline: none
    label
      margin-right: 14px
    .v-autocomplete-list
      z-index: 200
      position: absolute
      width: 100%
      text-align: left
      border-radius: 2px
      background-color: #ffffff
      border: solid 1px #e6e8ea
      margin-top: 2px
      position: absolute

      .v-autocomplete-list-item
        position: relative
        cursor: pointer
        height: 30px
        line-height: 30px !important
        background-color: #fff
        padding-left: 12px
        font-size: 12px
        text-align: justify
        color: #8d99a2

        &:hover
          background-color: $reev-base-green
          &::before
            position: absolute
            content: " "
            right: 9px
            top: calc(50% - 3.5px)
            width: 7px
            height: 7px
            background-image: url('../../assets/images/autocomplete-selection-arrow.svg')

  .fake-width
    width: 20%
    padding-right: 0px

  .fake-half-width
    width: 11.6667%
    padding-right: 0px

  .no-padding-right
    padding-right: 0px

  .input-delay
    max-width: 50px
    height: 38px

  .input-delay-options
    max-width: 180px

  .inline-options
    display: -webkit-inline-box

  .line-left
    border-left: 1px solid $reev-base-green
    height: 15%
    width: 1px
    position: absolute
    top: 33px

  .contact-list-item-flow
    margin-bottom: 0px

  .no-padding
    padding-left: 0px
    padding-right: 0px
    display: inline-flex

  .fill-property-field
    width: 50%
    margin: 0 5px 0 5px

  .line-faker
    position: absolute;
    left: 0
    border-left: 1px solid $reev-base-green
    height: 40px
    bottom: 30px

  .no-border
    border: 0
</style>



// WEBPACK FOOTER //
// triggers.vue?33f4d494